import React from "react";

const PlaneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M34.2666 6.51667C35.25 7.50001 35.25 9.08334 34.2666 10.05L27.7833 16.5333L31.3167 31.85L28.9666 34.2167L22.5 21.8333L16 28.3333L16.6 32.45L14.8167 34.2167L11.8833 28.9167L6.56665 25.9667L8.33332 24.1667L12.5 24.7833L18.95 18.3333L6.56665 11.8167L8.93332 9.46667L24.25 13L30.7333 6.51667C31.6666 5.55001 33.3333 5.55001 34.2666 6.51667Z"
        fill="#14141E"
      />
    </svg>
  );
};

export default PlaneIcon;
